<template>
  <div v-if="portalModel != null" id="show-portal-model">
    <v-row>
      <v-col cols="12">
        <edit-portal-model-dialog :portal-model="portalModel">
          <v-icon left>mdi-square-edit-outline</v-icon>
          Editer le modèle
        </edit-portal-model-dialog>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-tabs class="mt-2" v-if="langs.length > 0">
          <v-tab v-for="lang in langs" :key="lang" :href="`#tab-${lang}`">
            {{ lang }}
          </v-tab>

          <v-tab-item
            class="pl-2 pt-2"
            v-for="lang in langs"
            :key="lang"
            :value="'tab-' + lang"
            style="background-color: white"
          >
            <v-textarea
              label="Traduction complète en JSON"
              v-model="currentTranslation[lang]"
              rows="25"
            >
            </v-textarea>

            <v-btn
              class="primary my-3"
              @click="
                updatePortalModelTranslation(
                  currentTranslation,
                  portalModel.id,
                  lang
                )
              "
              >Mettre à jour</v-btn
            >
          </v-tab-item>
        </v-tabs>
        <div v-else>
          <p>
            La configurations semble avoir un problème car il n'y a pas de
            langues définis.
          </p>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { onMounted, toRefs, ref } from "@vue/composition-api";
import router from "../router";
import { usePortalModel } from "@/composables/portal-model";
import { useTranslation } from "@/composables/translation";
import EditPortalModelDialog from "@/components/PortalModel/EditPortalModelDialog";
import { useTitle } from "@/composables/title";
export default {
  components: { EditPortalModelDialog },
  setup() {
    const { setTitle } = useTitle();

    const { portalModelData, showPortalModel } = usePortalModel();
    const {
      getPortalModelTranslation,
      updatePortalModelTranslation,
      translationData,
      currentTranslation,
    } = useTranslation();
    const portalModelId = router.currentRoute.params.id;
    const langs = ref([]);
    onMounted(async () => {
      await showPortalModel(portalModelId);
      setTitle("Modèle de portail - " + portalModelData.portalModel.name);

      if (portalModelData.portalModel.configuration.languages != undefined) {
        langs.value = portalModelData.portalModel.configuration.languages;
        langs.value.forEach((lang) => {
          getPortalModelTranslation(portalModelId, lang);
        });
      }
    });

    return {
      ...toRefs(portalModelData),
      ...toRefs(translationData),
      currentTranslation,
      updatePortalModelTranslation,
      langs,
    };
  },
};
</script>
